<template>
  <div class="container">
    <loading-wrap :loading="loading">
      <div class="row justify-content-center pt-5">
        <div class="col-8">
          <div class="d-flex justify-content-between mb-3">
            <span>
              <button
                type="button"
                @click="addCategory()"
                class="btn btn-primary"
              >
                <span>Add Question Category</span>
              </button>
            </span>
          </div>
          <hr />
          <h5>Question Categories</h5>
          <template v-if="completed.length">
            <category-card v-for="a in completed" :category="a" :key="a._id" />
          </template>
          <no-results v-else />
        </div>
      </div>
    </loading-wrap>
  </div>
</template>

<script>
export default {
  data() {
    return {
      completed: [],
      loading: true,
    };
  },
  methods: {
    addCategory() {
      this.$_openCategoryModal();
    },
  },
  created() {
    this.axios
      .get(`${process.env.VUE_APP_API_URL}/api/categorys`)
      .then((res) => {
        this.completed = res.data;
        this.loading = false;
      });
  },
};
</script>
